import api from "../../api";
import { CreateInvoiceEndPoint } from "../../api/apisUrl";
import { invoiceProduct } from "../../models";
import {
  ADD_CREATE_INVOICE_FAILED,
  ADD_CREATE_INVOICE_LOADING,
  ADD_CREATE_INVOICE_SUCCESS,
  REMOVE_CREATE_INVOICE,
} from "../types";

export const createInvoice = (
  token: any,
  merchantId: string,
  userId: string,
  customerId: string,
  timeStamp: Date,
  name: string,
  email: string,
  phoneNum: string,
  address: string,
  language: string,
  vatId: string,
  productsList: invoiceProduct[],
  sendBy: string,
  invoiceStatus: boolean,
  totalItem: number,
  totalWithoutTax: string,
  taxValue: string,
  subTotal: string,
  discount: string,
  shipingPrice: string,
  invoiceTotal: string,
  description: string,
  idempotencyKey: string,
  customerType?: string,
  accountNumber?: string,
  bankName?: string,
  nationalId?: string,
  nationalIdIssueDate?: string,
  nationalIdIssuePlace?: string,
  legalForm?: string,
  capitalAmount?: number,
  registrationNumber?: string,
  fiscalId?: string,
  status = "created",
) => {
  return async (
    dispatch: (arg0: {
      type: string;
      loading?: boolean;
      payload?: any;
      status?: any;
      error?: any;
    }) => void,
  ) => {
    dispatch({ type: ADD_CREATE_INVOICE_LOADING, loading: true });
    // Generate idempotency key once per page render (persists across retries)
    await api
      .post(
        CreateInvoiceEndPoint(),
        JSON.stringify({
          merchantId,
          userId,
          customer: {
            customerId: customerId,
            name,
            email,
            phoneNum,
            address,
            language,
            vatId,
            customerType,
            accountNumber,
            bankName,
            nationalId,
            nationalIdIssueDate,
            nationalIdIssuePlace,
            legalForm,
            capitalAmount,
            registrationNumber,
            fiscalId,
          },
          timeStamp,
          products: productsList,
          shipingPrice,
          sendBy,
          totalItem,
          subTotal,
          discount,
          totalWithoutTax,
          taxValue,
          invoiceTotal,
          invoiceStatus,
          description,
          status,
        }),
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
            "Idempotency-Key": idempotencyKey,
          },
        },
      )
      .then((res) => {
        dispatch({ type: ADD_CREATE_INVOICE_LOADING, loading: false });
        dispatch({
          type: ADD_CREATE_INVOICE_SUCCESS,
          payload: res.data,
          status: res.status,
        });
      })
      .catch((err) => {
        dispatch({ type: ADD_CREATE_INVOICE_LOADING, loading: false });
        if (err.response) {
          if (err.response.data.message) {
            dispatch({
              type: ADD_CREATE_INVOICE_FAILED,
              status: err.status,
              error: err.response.data.message,
            });
          } else {
            dispatch({
              type: ADD_CREATE_INVOICE_FAILED,
              status: err.status,
              error:
                "Something error !! Please contact the technical administrator.",
            });
          }
        } else if (err.request) {
          dispatch({
            type: ADD_CREATE_INVOICE_FAILED,
            error: "Something error in your request !!",
          });
        } else {
          dispatch({
            type: ADD_CREATE_INVOICE_FAILED,
            error:
              "Something error !! Please contact the technical administrator.",
          });
        }
      });
  };
};

export const RemoveCreateInvoice = () => {
  return {
    type: REMOVE_CREATE_INVOICE,
  };
};
